import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Customer } from '@inyova/models';

import { Store } from '@ngrx/store';
import * as ProfileActions from '@profile/profile.actions';

import { phoneValidator } from '@app/validators/phone-validator';

@Component({
  selector: 'app-profile-2fa-phone',
  styleUrls: ['./profile-2fa-phone.component.scss'],
  templateUrl: './profile-2fa-phone.component.html',
  standalone: false
})
export class Profile2FAPhoneComponent implements OnChanges {
  @Input() customer: Customer;
  @Input() enabled2FA: boolean;
  @Input() loading: boolean;
  @Input() token: string;

  has3AAccountMinProspect: boolean;
  editPhoneNumberView: boolean;
  phoneNumber: string;
  phoneNumberForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store
  ) {
    this.phoneNumberForm = this.formBuilder.group({
      phoneNumber: ['', [Validators.required, phoneValidator]]
    });
  }

  changePhoneNumber(): void {
    this.phoneNumberForm.get('phoneNumber').setValue(this.phoneNumber);
    this.editPhoneNumberView = true;
  }

  goBack(): void {
    if (this.editPhoneNumberView) {
      this.editPhoneNumberView = false;
    } else {
      this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'main' }));
    }
  }

  send(): void {
    if (this.editPhoneNumberView) {
      if (this.phoneNumberForm.invalid) {
        this.phoneNumberForm.get('phoneNumber').markAllAsTouched();
        return;
      }

      this.store.dispatch(
        ProfileActions.updateCustomerPhoneAndSend2FACode({
          authToken: this.token,
          personalDetails: { phone: this.phoneNumberForm.get('phoneNumber').value }
        })
      );
      return;
    }
    this.store.dispatch(ProfileActions.send2FAAuthorizationCode({ authToken: this.token, redirect: 'verify' }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customer) {
      const customer = changes.customer.currentValue as Customer;
      this.has3AAccountMinProspect = customer.accounts.some((account) => account.kind === '3a' && account.step_status > 2);
      if (this.has3AAccountMinProspect) {
        this.phoneNumber = customer.verified_phone || customer.unverified_phone;
      } else {
        this.phoneNumber = customer.unverified_phone || customer.verified_phone;
      }

      this.editPhoneNumberView = this.phoneNumber ? !this.phoneNumber.length : true;
    }
  }
}
